const characterQuestions = [
    {
        question: "What is your character's name",
        label: "... or nickname",
        ref: "name"
    },
    {
        question: "What is your character's age",
        label: "... in years",
        ref: "age"
    },
    {
        question: "What is your character's gender",
        label: '... male, female, something else',
        ref: "gender"
    },
    {
        question: "What is your character's hair color",
        label: "... brown, blonde, black...",
        ref: "hairColor"
    },
    {
        question: "What is your character's eye color",
        label: '... blue, green, purple...',
        ref: "eyeColor"
    },
    {
        question: "What is your character's height",
        label: '... tall, medium, short',
        ref: "height"
    },
    {
        question: "Where was your character born",
        label: "... where are they from",
        ref: "born"
    },
    {
        question: "Where does your character live now",
        label: "... where do they live now",
        ref: "lives"
    },
    {
        question: "Does your character have a special ability",
        label: "... superpower? ..Or excellent at something",
        ref: "specialAbility"
    },
    {
        question: "Does your character have a favorite items",
        label: "... any item they really like",
        ref: "favoriteItem"
    },
    {
        question: "Does your character have a favorite hobbies",
        label: "... anything they love to do",
        ref: "hobby"
    },
    {
        question: "Any extra details we could know about your character",
        label: "... how they feel, what they want, anything",
        ref: "extraDetails"
    },
    {
        question: "What is the relation to the other characters",
        label: '... e.g. James is my brother and Mary is my Mother',
        ref: "relations"
    },
]

export default characterQuestions;